import { MissionData } from '../blocks/mission'
import template from './templates/RJF08.rbxl'
import thumbnail1 from './thumbnails/RJF08/BlueWall.png'
import thumbnail2 from './thumbnails/RJF08/GreenWall.png'
import thumbnail3 from './thumbnails/RJF08/RedWall.png'
import thumbnail4 from './thumbnails/RJF08/YellowWall.png'
import thumbnail5 from './thumbnails/RJF08/Trap.png'

const mission: MissionData = {
  // Set the template and other metadata.
  // テンプレートとその他のメタデータを設定します。
  number: 2,
  stage: 0,
  thumbnail: '',
  title: '',
  template,
  chapters: [{}, {}, {}, {}, {}],
  objects: [
    {
      name: '①あおいカベ',
      thumbnail: thumbnail1,
    },
    {
      name: '②みどりのカベ',
      thumbnail: thumbnail2,
    },
    {
      name: '③あかいカベ',
      thumbnail: thumbnail3,
    },
    {
      name: '④きいろいカベ',
      thumbnail: thumbnail4,
    },
    {
      name: '⑤トラップ',
      thumbnail: thumbnail5,
    },
  ],
}

export default mission
